import styled from 'styled-components';
import SectionContainer from '@common/components/SectionContainer';

export const HeaderWrapper = styled(SectionContainer)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

export const RightSection = styled.div`
  display: flex;
  gap: 1rem;
`;
